import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import * as Objects from '@core/objects';

@Component({
    selector: 'project-details-versions-relateds-list',
    templateUrl: './relateds-list.component.html',
    styleUrls: ['./relateds-list.component.scss']
})
export class ProjectDetailsVersionsRelatedsListComponent implements OnInit, OnChanges {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2;

    @Input() project: Objects.Request;
    @Input() relateds: Array<Objects.RelatedVersions> = null;

    public status:number = this.STATUS_LOADING;
    public groupsDisplayFlags: boolean[] = [];

    ngOnInit() {
        if(this.relateds != null){
            this.initDisplayFlags(); // set display manager
            this.status = this.STATUS_DONE;
        } else {
            this.status = this.STATUS_LOADING;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.relateds){
            if (this.relateds != null){
                // set display manager
                this.initDisplayFlags();
                this.status = this.STATUS_DONE;
            }
        }
    }

    public onClickGroup(display: boolean, index: number){
        this.groupsDisplayFlags[index] = display;


    }

    public isDisplayed(index: number): boolean {
        return this.groupsDisplayFlags[index];
    }

    protected initDisplayFlags(): void {
        this.relateds.forEach((group: Objects.Related, index: number) => {
            this.groupsDisplayFlags[index] = true;
        });

    }

}
